export const REGISTRATION_DATA_STATUS = {
  INCOMPLETE: "INCOMPLETE",
  SUBMITTED: "SUBMITTED",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  SUBMITTED: "SUBMITTED"
};
